
function Background() {
  return <img className="background" src="/assets/images/img_background.png" alt="background" />;
}
export default Background;